import { call, put, takeEvery, all, fork } from "redux-saga/effects";

// Crypto Redux States
import {
  GET_CHARTS_DATA,
  GET_AID_REQUEST,
  GET_TOTALLABS_REQUEST,
  GET_TOTALEARNINGS_REQUEST,
  GET_TOTALCOMPLAINTS_REQUEST,
  GET_TOTALFA_REQUEST,
  GET_USERSTATS_REQUEST,
} from "./actionTypes";
import {
  apiSuccess,
  apiFail,
  getAllAidListRequest,
  getAllAidListSuccess,
  getAllAidListFail,
  getTotalLabsListRequest,
  getTotalLabsListSuccess,
  getTotalLabsListFail,
  getTotalEarningsListRequest,
  getTotalEarningsListSuccess,
  getTotalEarningsListFail,
  getTotalComplaintsListSuccess,
  getTotalComplaintsListFail,
  getTotalFAListSuccess,
  getTotalFAListFail,
  getUserStatsListSuccess,
  getUserStatsListFail,
} from "./actions";

//Include Both Helper File with needed methods
import {
  getWeeklyData,
  getYearlyData,
  getMonthlyData,
} from "../../helpers/fakebackend_helper";
import axios from "axios";
import { url } from "APIs/URLS";

function* getChartsData({ payload: periodType }) {
  try {
    var response;
    if (periodType == "monthly") {
      response = yield call(getWeeklyData, periodType);
    }
    if (periodType == "yearly") {
      response = yield call(getYearlyData, periodType);
    }
    if (periodType == "weekly") {
      response = yield call(getMonthlyData, periodType);
    }

    yield put(apiSuccess(GET_CHARTS_DATA, response));
  } catch (error) {
    yield put(apiFail(GET_CHARTS_DATA, error));
  }
}
const AllAidListAPICall = async () => {
  try {
    const response = await axios.get(`${url}/Finance/getdonationsstats`);
    console.log("data = " + response.data);
    console.log("data fetched sucessfully= " + response.data.name);
    return response.data;
  } catch (error) {
    console.log("error = " + error);

    throw error;
  }
};

function* getAllAidsList() {
  try {
    const response = yield call(AllAidListAPICall);
    console.log("data = " + response.data);
    yield put(getAllAidListSuccess(response));
  } catch (error) {
    console.log("error = " + error);
    yield put(getAllAidListFail(error));
  }
}
const TotalLabsListAPICall = async () => {
  try {
    const response = await axios.get(`${url}/profiles/totallabs`);
    console.log("data = " + response.data);
    console.log("data fetched sucessfully= " + response.data.name);
    return response.data;
  } catch (error) {
    console.log("error = " + error);

    throw error;
  }
};

function* getTotalLabsList() {
  try {
    const response = yield call(TotalLabsListAPICall);
    console.log("data = " + response.data);
    yield put(getTotalLabsListSuccess(response));
  } catch (error) {
    console.log("error = " + error);
    yield put(getTotalLabsListFail(error));
  }
}
const TotalEarningsListAPICall = async () => {
  try {
    const response = await axios.get(`${url}/Appointments/totalearnings`);
    console.log("data = " + response.data);
    console.log("data fetched sucessfully= " + response.data.name);
    return response.data;
  } catch (error) {
    console.log("error = " + error);

    throw error;
  }
};

function* getTotalEarningsList() {
  try {
    const response = yield call(TotalEarningsListAPICall);
    console.log("data = " + response.data);
    yield put(getTotalEarningsListSuccess(response));
  } catch (error) {
    console.log("error = " + error);
    yield put(getTotalEarningsListFail(error));
  }
}
const TotalComplaintsListAPICall = async () => {
  try {
    const response = await axios.get(`${url}/Feedbacks/gettotalcomplaints`);
    console.log("data = " + response.data);
    console.log("data fetched sucessfully= " + response.data.name);
    return response.data;
  } catch (error) {
    console.log("error = " + error);

    throw error;
  }
};

function* getTotalComplaintsList() {
  try {
    const response = yield call(TotalComplaintsListAPICall);
    console.log("data = " + response.data);
    yield put(getTotalComplaintsListSuccess(response));
  } catch (error) {
    console.log("error = " + error);
    yield put(getTotalComplaintsListFail(error));
  }
}
const TotalFAListAPICall = async () => {
  try {
    const response = await axios.get(`${url}/Finance/gettotalFa`);
    console.log("data = " + response.data);
    console.log("data fetched sucessfully= " + response.data.name);
    return response.data;
  } catch (error) {
    console.log("error = " + error);

    throw error;
  }
};

function* getTotalFAList() {
  try {
    const response = yield call(TotalFAListAPICall);
    console.log("data = " + response.data);
    yield put(getTotalFAListSuccess(response));
  } catch (error) {
    console.log("error = " + error);
    yield put(getTotalFAListFail(error));
  }
}
const UserStatsListAPICall = async () => {
  try {
    const response = await axios.get(`${url}/profiles/userstats`);
    console.log("data = " + response.data);
    console.log("data fetched sucessfully= " + response.data.name);
    return response.data;
  } catch (error) {
    console.log("error = " + error);

    throw error;
  }
};

function* getUserStatsList() {
  try {
    const response = yield call(UserStatsListAPICall);
    console.log("data = " + response.data);
    yield put(getUserStatsListSuccess(response));
  } catch (error) {
    console.log("error = " + error);
    yield put(getUserStatsListFail(error));
  }
}
//BLOCK LAB

export function* watchGetChartsData() {
  yield takeEvery(GET_CHARTS_DATA, getChartsData);
  yield takeEvery(GET_AID_REQUEST, getAllAidsList);
  yield takeEvery(GET_TOTALLABS_REQUEST, getTotalLabsList);
  yield takeEvery(GET_TOTALEARNINGS_REQUEST, getTotalEarningsList);
  yield takeEvery(GET_TOTALCOMPLAINTS_REQUEST, getTotalComplaintsList);
  yield takeEvery(GET_TOTALFA_REQUEST, getTotalFAList);
  yield takeEvery(GET_USERSTATS_REQUEST, getUserStatsList);
}

function* dashboardSaga() {
  yield all([fork(watchGetChartsData)]);
}

export default dashboardSaga;
